import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import ReactCardFlip from 'react-card-flip';
// material
import { styled } from '@mui/material/styles';
import { Card, Stack, Link, Container, Typography, Box, ImageListItem } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google'; // Add an icon for Google
import FacebookIcon from '@mui/icons-material/Facebook'; // Add an icon for Facebook
// layouts
// import AnimationControl from '../Components/animation-control/animationControl';
// components
// import Page from '../Components/Page';
import Page from '../Page';
// import AiAnalyst from '../../assets/AI-Analyst.svg';
import AiAnalyst from '../../assets/StoryLane.svg';
import { MHidden } from '../@material-extend';
import { LoginForm } from '../../Components/authentication/login';
import UserRegistrationForm from '../UserRegistrationForm';
import { Notification } from '../Notification/Notification';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)({
  display: 'flex',
  height: '100vh',
  overflow: 'hidden', // <-- prevent scrollbar
});

const SectionStyle = styled('div')(() => ({
  width: '100%',
  maxWidth: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}));

const ContentStyle = styled('div')(() => ({
  // height: '100vh',
  // flexDirection: 'column',
  // justifyContent: 'center'
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
}));

// ----------------------------------------------------------------------

export default function Login() {
  const navigate = useNavigate();
  const [isFlipped, setIsFlipped] = useState(false);

  const handleFlipToRegister = () => {
    setIsFlipped(true);
  };

  const handleFlipToLogin = () => {
    setIsFlipped(false);
  };
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertType, setAlertType] = useState('');
  const handleAlert = () => {
    setAlert(false);
  };
  return (
    <RootStyle title="Login">
      <MHidden width="mdDown" sx={{ width: '50%', justifyContent: 'center' }}>
        <SectionStyle sx={{ justifyContent: 'center', height: '100vh', overflow: 'hidden' }}>
          <div
            style={{
              background: 'linear-gradient(180deg, #DFF1FC 0%, #06446F 100%)', // Gradient background
              backgroundSize: 'cover',
              marginLeft: '10vh',
              borderRadius: '24px',
              height: '90vh',
              position: 'relative', // Parent should have relative positioning
              width: '95vh'
            }}
          >
            <div>
              <Typography
                sx={{
                  position: 'absolute', // Absolutely position the text
                  top: 0,
                  left: 0,
                  margin: '22px', // Add margin for spacing
                  // color: '#0381FE', // Adjust text color
                  background: 'linear-gradient(90deg, #0053A6 0%, #04284C 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  fontSize: '42px',
                  fontWeight: 900,
                  lineHeight: '42px',
                  textAlign: 'left'
                }}
              >
                inteliconvo
              </Typography>
              <Typography
                sx={{
                  position: 'absolute', // Absolutely position the text
                  top: 0,
                  left: 0,
                  marginTop: '67px',
                  marginLeft: '22px',
                  background: 'linear-gradient(90deg, #F92B9A 0%, #2B64F9 112.29%)',
                  WebkitBackgroundClip: 'text', // Clip the background to the text
                  WebkitTextFillColor: 'transparent', // Make the text transparent to show the background
                  fontSize: '18px', // font-size: 18px;
                  fontWeight: 900 // font-weight: 500;
                  // lineHeight: '18px', // line-height: 18px;
                }}
              >
                {/* Powered by Generative AI. */}
              </Typography>
              <Typography
                sx={{
                  position: 'absolute', // Absolutely position the text
                  top: 0,
                  left: 0,
                  marginTop: '100px',
                  marginLeft: '22px',
                  color: '#292D32',
                  fontSize: '14px',
                  fontWeight: 500,
                  lineHeight: '17px'
                }}
              >
                {/* Decode voice of customer to enhance CSAT, Improve service quality and boost customer
                                loyalty. */}
              </Typography>
            </div>
            <ImageListItem>
              <img
                src={AiAnalyst} // Use src attribute for img
                alt="login"
                style={{
                  marginTop: '155px',
                  width: '95vh', // Adjust the size of the image
                  height: '65vh',
                  objectFit: 'cover' // Ensure the image scales correctly
                }}
              />
            </ImageListItem>
            {/* </div> */}
          </div>
        </SectionStyle>
      </MHidden>

      <Container sx={{ width: '50%', marginRight: '20vh' }}>
        <ContentStyle sx={{ marginLeft: '10vh' }}>
          <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
            <Card
              sx={{
                width: isFlipped ? 650 : 380,
                maxWidth: '95vw'
              }}
            >
              <LoginForm
                onRegisterClick={handleFlipToRegister}
                setAlertContent={setAlertContent}
                setAlertType={setAlertType}
                setAlert={setAlert}
              />
            </Card>

            <Card
              sx={{
                width: isFlipped ? 450 : 380,
                maxWidth: '95vw'
              }}
            >
              <UserRegistrationForm
                onLoginClick={handleFlipToLogin}
                setAlertContent={setAlertContent}
                setAlertType={setAlertType}
                setAlert={setAlert}
              />
            </Card>
          </ReactCardFlip>
        </ContentStyle>
      </Container>
      <Notification
        open={alert}
        message={alertContent}
        severity={alertType}
        handleClose={handleAlert}
      />
    </RootStyle >
  );
}
